<template>
  <sAlert
    class="version"
    show-icon>
    {{ $t('Common.ApplicationInformation') }}
    <template slot="desc">
      <div>{{ $t('Common.Version') }}: {{ version }}</div>
      <div>{{ $t('Common.BuildVersion') }}: {{ buildVersion }}</div>
    </template>
  </sAlert>
</template>
<script>
/**
 * Простая страница с версией сборки
 * сайт/version
 */
export default {
  name: 'version',
  computed: {
    version: {
      get() {
        return window.config.Version
      }
    },
    buildVersion: {
      get() {
        return window.config.BuildVersion
      }
    }
  }
}
</script>
<style scoped>
.version {
  width: fit-content;
  margin: 20px auto;
}
</style>
